import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "workspace-modal" }
const _hoisted_2 = { class: "modal-wrap" }
const _hoisted_3 = { class: "workspace-modal-body" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "workspace-item" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "workspace-modal-footer" }
const _hoisted_12 = ["src"]

import user1 from '@/assets/icon/persona/user1.svg';
import plus from '@/assets/icon/menu/plus.svg';
import workspaceData from '@/static/data/workspaceData';
import { setPersona } from '@/utils/personaUtils';

export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "workspace-modal-header" }, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, "Workspace List")
        ]),
        _createElementVNode("hr")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
          : (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
            : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_router_link, { to: "/my/dashboard" }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(user1),
                          alt: "user"
                        }, null, 8, _hoisted_8),
                        _cache[0] || (_cache[0] = _createElementVNode("p", null, "My Space", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workspaceData), (workspaceItem, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("button", {
                      class: "workspace-item",
                      onClick: ($event: any) => (_ctx.handleWorkspaceSelection(workspaceItem))
                    }, [
                      _createElementVNode("img", {
                        width: "30px",
                        src: _unref(setPersona)(workspaceItem.avatar),
                        alt: "workspace"
                      }, null, 8, _hoisted_10),
                      _createElementVNode("div", null, _toDisplayString(workspaceItem.workspaceName), 1)
                    ], 8, _hoisted_9)
                  ]))
                }), 128))
              ]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/my/create" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(plus),
                class: "plus",
                alt: "plus-btn"
              }, null, 8, _hoisted_12),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Add Workspace", -1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})